import React from "react"
import styled from "styled-components"
import logoCokeHeaderDark from "../assets/header-logo-coke-only.svg"
import logoCokePeru from "../assets/header-logo-coke-peru.png"
import HeaderPoints from "./HeaderPoints"
import { normalizeCountry } from "../utils/normalizeCountry"
import { useResto } from "../hooks/useResto"
import { useUser } from "../hooks/useUser"
import { useOwnerRestaurantSelection } from "../hooks/useOwnerRestaurantSelection"
import { ACTIVE_HEADER_VARIANT, HEADER_VARIANTS } from "../config/headerTheme"

const Banner = styled.div`
  --header-primary: ${() => HEADER_VARIANTS[ACTIVE_HEADER_VARIANT].primary};
  --header-avatar-border: ${() => HEADER_VARIANTS[ACTIVE_HEADER_VARIANT].avatarBorder};

  position: relative;
  width: 100%;
  max-width: 1200px;
  height: 120px;
  margin: 0 auto 44px;
  background: var(--header-primary);
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const BannerTitle = styled.h2`
  position: absolute;
  top: 16px;
  left: 20px;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  text-align: left;
  max-width: calc(50% - 80px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const PointsWrap = styled.div`
  position: absolute;
  left: 20px;
  bottom: 16px;
  z-index: 2;
  max-width: calc(50% - 80px);
`

const Circle = styled.div`
  position: absolute;
  bottom: -40px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 120px;
  background: #fff!important;
  border-radius: 50%;
  border: 2px solid var(--header-avatar-border);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

const CokeBrand = styled.div`
  position: absolute;
  right: 20px;
  bottom: 16px;
  width: 96px;
  pointer-events: none;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`

export default function BannerDesktop({
  img = null,
  alt = "",
  title = "",
  country = "",
  showCokeBrand = true,
  points = 0,
  loaderPoints = false,
  labelPoints = "Puntos",
  showPoints = true,
}) {
  const { resto } = useResto()
  const { isResto } = useUser()
  const { selectedOwnerRestaurant } = useOwnerRestaurantSelection()

  const resolvedCountry =
    country ||
    selectedOwnerRestaurant?.country ||
    selectedOwnerRestaurant?.pais ||
    resto?.country ||
    resto?.pais ||
    ""

  const normalizedCountry = normalizeCountry(resolvedCountry)
  const isPeruCokeLogo = normalizedCountry === "peru" || normalizedCountry === "pe"
  const cokeHeaderLogo = isPeruCokeLogo ? logoCokePeru : logoCokeHeaderDark
  const shouldShowCokeBrand = showCokeBrand && isResto

  return (
    <Banner>
      {title && <BannerTitle>{title}</BannerTitle>}
      {showPoints && (
        <PointsWrap>
          <HeaderPoints points={points} label={labelPoints} loader={loaderPoints} />
        </PointsWrap>
      )}
      {shouldShowCokeBrand && (
        <CokeBrand $isPeru={isPeruCokeLogo}>
          <img
            src={cokeHeaderLogo}
            alt={isPeruCokeLogo ? "Coca-Cola Perú" : "Coca-Cola"}
          />
        </CokeBrand>
      )}
      <Circle>
        <img src={img} alt={alt} />
      </Circle>
    </Banner>
  )
}
